/**
 * Quick Bytes - microlearning highlights feed.
 *
 * Doom-scroll / Instagram-style reader over the lesson highlights
 * generated for every lesson the user has run. Filters (search,
 * source lessons, tags, time window, due-today) live in the URL
 * via `useTagFilters` so any filtered session is shareable.
 *
 * Spaced-repetition review used to share this page; it's been removed
 * in favor of a focused highlights-only surface. The underlying
 * QuickBytesScroller / queue endpoint stay in the codebase for now in
 * case a future surface (Practice Arena, daily-plan card) wants them.
 */

import { MindspaceLayout } from '@/components/features/mindspace/MindspaceLayout';
import { QuickBytesFilterPanel } from '@/components/features/mindspace/quick-bytes/QuickBytesFilterPanel';
import { QuickBytesGrid } from '@/components/features/mindspace/quick-bytes/QuickBytesGrid';
import { QuickBytesPhoneHeader } from '@/components/features/mindspace/quick-bytes/QuickBytesPhoneHeader';
import { useActivityTracking } from '@/hooks/useActivityTracking';
import { useMediaQuery } from '@/hooks/ui/useMediaQuery';

export function QuickBytesPage() {
  // Activity tracking - minutes here roll into ContentActivity, feed
  // StudySession.activity_count, and contribute to streak.
  useActivityTracking({ contentType: 'quick_bytes' });
  // Below `md` the page has its own header (`QuickBytesPhoneHeader`): the
  // Filters button, the count and the All | Bookmarks switch, with the
  // filter sheet owned there - so the layout gets no panel and draws no
  // icon up by Back.
  const compact = useMediaQuery('(max-width: 767.98px)');

  if (compact) {
    return (
      <MindspaceLayout>
        <QuickBytesPhoneHeader />
        <div className='flex min-h-0 flex-1 flex-col'>
          <QuickBytesGrid />
        </div>
      </MindspaceLayout>
    );
  }

  return (
    <MindspaceLayout filterPanel={<QuickBytesFilterPanel />}>
      <div className='flex h-full flex-col'>
        <header className='flex h-16 flex-shrink-0 items-center border-b border-border px-4'>
          <h2 className='text-xl font-semibold text-foreground'>Quick Bytes</h2>
        </header>
        <div className='flex min-h-0 flex-1 flex-col'>
          <QuickBytesGrid />
        </div>
      </div>
    </MindspaceLayout>
  );
}
